/** 格式化日期为 "Mon DD, YYYY" */ export function formatDate(dateStr) {
    if (!dateStr) {
        return '';
    }
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
}
/** Markdown 内容提取纯文本预览 */ export function extractPreview(markdown) {
    let maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 240;
    return markdown.replace(/!\[[^\]]*\]\([^)]*\)/g, '').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/```[\s\S]*?```/g, ' ').replace(/`([^`]*)`/g, '$1').replace(/<[^>]+>/g, ' ').replace(/[#>*_~\-]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, maxLength).trim();
}
export function hasNotificationMedia(coverType, coverUrl) {
    return Boolean(coverType && coverUrl);
}
export function isVideoCover(coverType) {
    return coverType === 'video';
}
const FOOTER_ACTION_DEFAULT_I18N = {
    external_url: 'workspace.notifications.footerAction.externalUrl',
    feedback: 'workspace.notifications.footerAction.feedback',
    get_started: 'workspace.notifications.footerAction.getStarted',
    upgrade: 'workspace.notifications.footerAction.upgradeNow',
    view_credits: 'workspace.notifications.footerAction.viewCredits'
};
/** 取单个 footerAction item 的展示文案，优先运营自定义 label，缺失走 i18n 默认文案 */ function getFooterActionItemLabel(item) {
    var _item_label;
    if ((_item_label = item.label) === null || _item_label === void 0 ? void 0 : _item_label.trim()) {
        return item.label.trim();
    }
    const i18nKey = FOOTER_ACTION_DEFAULT_I18N[item.type];
    if (!i18nKey) {
        return null;
    }
    return intl.get(i18nKey);
}
/** 过滤无效 footerAction（external_url 缺 url、或文案为空），同时返回展示文案 */ export function getValidFooterActions(actions) {
    if (!actions || actions.length === 0) {
        return [];
    }
    const result = [];
    for (const action of actions){
        if (action.type === 'external_url' && !action.url) {
            continue;
        }
        const label = getFooterActionItemLabel(action);
        if (!label) {
            continue;
        }
        result.push({
            action,
            label
        });
    }
    return result;
}
